module.exports = __webpack_public_path__ + "static/eis2-3bdbeb8ab65cf39e650d2aa754923005.jpg";